import { motion } from 'framer-motion';
import { FileCheck, DollarSign, Clock, Star } from 'lucide-react';

const steps = [
  { icon: FileCheck, num: '01', title: 'Work Done to NEC Code Every Time', desc: 'Licensed & insured electrician you can trust. Every job meets or exceeds National Electrical Code standards.' },
  { icon: DollarSign, num: '02', title: 'Straightforward Pricing', desc: 'Detailed estimates based on your requirements and budget. No hidden fees, no surprises. Ever.' },
  { icon: Clock, num: '03', title: 'On-Time & Respectful', desc: 'We arrive on time, keep your property clean, and treat your home or business like our own.' },
  { icon: Star, num: '04', title: '5-Star Communication', desc: 'Clear updates throughout the project. We explain your options so you can make informed decisions.' },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.5, delay: i * 0.12 } }),
};
const fadeIn = { initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true } };
const fadeInUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };
const halfSec = { duration: 0.5 };
const viewportOnce = { once: true };

function StepCard({ step, index, isLast }) {
  return (
    <motion.div key={step.num} initial="hidden" whileInView="visible" viewport={viewportOnce}
      variants={fadeUp} custom={index}
      className={`relative p-8 ${!isLast ? 'lg:border-r border-b lg:border-b-0 border-zinc-200' : ''}`}
      data-testid={`process-step-${step.num}`}>
      <span className="font-display text-6xl text-zinc-100 absolute top-4 right-4">{step.num}</span>
      <step.icon className="w-7 h-7 text-yellow-500 mb-6 relative z-10" />
      <h3 className="font-heading text-base font-bold uppercase tracking-tight mb-3 relative z-10">{step.title}</h3>
      <p className="font-body text-sm text-zinc-500 leading-relaxed relative z-10">{step.desc}</p>
    </motion.div>
  );
}

export default function ProcessSection() {
  return (
    <section id="process" data-testid="process-section" className="py-24 sm:py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.p {...fadeIn} className="font-body text-xs uppercase tracking-[0.2em] text-zinc-400 mb-3">Our Process</motion.p>
        <motion.h2 {...fadeInUp} transition={halfSec} className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight uppercase mb-16">
          Why Homeowners Choose Us
        </motion.h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
          {steps.map((step, i) => <StepCard key={step.num} step={step} index={i} isLast={i === steps.length - 1} />)}
        </div>
      </div>
    </section>
  );
}
